import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    tabContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2),
    },
  };
};
